import { useAds } from '@/components/providers/AdsProvider'
import { getAdGatherersTavernPoster } from '@/defs/ad'

import { AdInHouse } from '../AdInHouse/AdInHouse'

type Props = {
  slugs: string[]
}

export const AdGatherersTavernPoster = ({ slugs }: Props) => {
  const { adsDisabled } = useAds()

  const adId = getAdGatherersTavernPoster(slugs)

  if (adsDisabled || !adId) return null

  return <AdInHouse id={adId} unit='poster' variant='poster' />
}
